// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-panel--markdown{font-size:14px;line-height:16px;padding:8px;border-radius:1px;transition:border-color .25s ease}.flow-panel--body .markdown-editor--monaco{position:relative}.flow-panel--body .markdown-editor--monaco .react-monaco-editor-container{min-height:100px}.flow-panel--markdown__placeholder.markdown-format{color:#68687b;font-style:italic}", ""]);
// Exports
module.exports = exports;
